import { Injectable } from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {ClaimSummaries, ClaimSummary} from '../../../../../models/claimSummary';
import {ClaimOverviewDataService} from '../../http/http-client-data/claim-overview-data/claim-overview-data.service';
import {ClaimOverviewSearchRequest} from '../../../../../models/ClaimOverviewSearchRequest';
import {ApplicationConstants} from '../../../../constants/application.constants';

@Injectable({
  providedIn: 'root'
})
export class ClaimSummaryService {

  constructor(
    private claimOverviewDataService: ClaimOverviewDataService
  ) { }

  private _claimSummary: ClaimSummary;
  private _claimNumber: string;
  private _claimExtensionNumber: string;
  private _claimSummaries: ClaimSummaries;
  private _serviceStartDateFrom: string;
  private _serviceStartDateTo: string;

  /***** START - PROPERTY ACCESSORS *****/
  get claimSummary(): ClaimSummary {
    return (this._claimSummary) ? Object.deepClone(this._claimSummary) : this._claimSummary;
  }

  set claimSummary(value: ClaimSummary) {
    this._claimSummary = value;
  }

  get claimNumber(): string {
    return this._claimNumber;
  }

  set claimNumber(value: string) {
    this._claimNumber = value;
  }

  get claimExtensionNumber(): string {
    return this._claimExtensionNumber;
  }

  set claimExtensionNumber(value: string) {
    this._claimExtensionNumber = value;
  }

  get claimSummaries(): ClaimSummaries {
    return this._claimSummaries;
  }

  set claimSummaries(value: ClaimSummaries) {
    this._claimSummaries = value;
  }

  get serviceStartDateFrom(): string {
    return this._serviceStartDateFrom;
  }

  set serviceStartDateFrom(value: string) {
    this._serviceStartDateFrom = value;
  }

  get serviceStartDateTo(): string {
    return this._serviceStartDateTo;
  }

  set serviceStartDateTo(value: string) {
    this._serviceStartDateTo = value;
  }

  /***** END - PROPERTY ACCESSORS *****/

  /***** START - PUBLIC FUNCTIONS *****/

  /**
   * Search Claim Overviews based on request object and claim status code
   * @param claimOverviewSearchRequest
   * @param statusCode
   */
  searchClaimOverviews(claimOverviewSearchRequest: ClaimOverviewSearchRequest, statusCode: string): Observable<ClaimSummaries> {
    if (Object.keys(ApplicationConstants.claimSummaryApiStatusCodes).includes(statusCode)) {
      const urlStatusCode: string = ApplicationConstants.claimSummaryApiStatusCodes[statusCode];
      return new Observable<ClaimSummaries>((observer: Subscriber<ClaimSummaries>) => {
        this.claimOverviewDataService.searchClaimOverviews(claimOverviewSearchRequest, urlStatusCode).subscribe((claimSummaries) => {
          this.claimSummaries = claimSummaries;
          observer.next(claimSummaries);
          observer.complete();
        });
      });
    }
  }

  /***** END - PUBLIC FUNCTIONS *****/

}
